module.exports = __webpack_public_path__ + "static/hero-pattern-106cece575396688e6313fafd2a864c3.webp";